import { Column } from 'hooks/useMuiTableBuilderV2';

export const COLUMNS = {
  CHECKBOX: 'checkbox',
  STATUS: 'status',
  UUID: 'id',
  TEAM_ID: 'teamId',
  TEAM_NAME: 'name',
  TENANT: 'tenant',
  REALM: 'realmId',
  INTEGRATIONS: 'integrations',
  CSM: 'csm',
  TAGS: 'tags',
  TEST_TEAM: 'internalTestTeam',
  DDI_ENABLED: 'ddiEnabled',
  SSO_ENABLED: 'ssoEnabled',
  OPENAPI_ENABLED: 'openApiEnabled',
  ARCHIVED_AT: 'archivedAt',
  REASON: 'reasonToArchive',
  LAST_BACKFILLED: 'lastBackfilled',
  SCHEDULED_DEACTIVATION_TIME: 'scheduledArchiveDate',
  EXPAND: 'expand',
} as const;

const checkboxColumn: Column = {
  id: COLUMNS.CHECKBOX,
  label: '',
  sortDisabled: true,
};

const statusColumn: Column = {
  id: COLUMNS.STATUS,
  label: 'Status',
  sortDisabled: true,
};

const uuidColumn: Column = {
  id: COLUMNS.UUID,
  label: 'UUID',
  sortDisabled: true,
};

const teamIdColumn: Column = {
  id: COLUMNS.TEAM_ID,
  label: 'Team ID',
};

const teamNameColumn: Column = {
  id: COLUMNS.TEAM_NAME,
  label: 'Team Name',
};

const tenantColumn: Column = {
  id: COLUMNS.TENANT,
  label: 'Tenant',
  sortDisabled: true,
};

const realmColumn: Column = {
  id: COLUMNS.REALM,
  label: 'Realm',
  sortDisabled: true,
};

const integrationsColumn: Column = {
  id: COLUMNS.INTEGRATIONS,
  label: 'Integrations',
  sortDisabled: true,
};

const csmColumn: Column = {
  id: COLUMNS.CSM,
  label: 'CSM',
};

const tagsColumn: Column = {
  id: COLUMNS.TAGS,
  label: 'Tags',
  sortDisabled: true,
};

const testTeamColumn: Column = {
  id: COLUMNS.TEST_TEAM,
  label: 'Is Test Team',
};

const ddiColumn: Column = {
  id: COLUMNS.DDI_ENABLED,
  label: 'DDI Enabled',
};

const ssoColumn: Column = {
  id: COLUMNS.SSO_ENABLED,
  label: 'SSO Enabled',
};

const openApiColumn: Column = {
  id: COLUMNS.OPENAPI_ENABLED,
  label: 'Open API Enabled',
};

const archivedAtColumn: Column = {
  id: COLUMNS.ARCHIVED_AT,
  label: 'Archived At',
};

const reasonColumn: Column = {
  id: COLUMNS.REASON,
  label: 'Reason To Archive',
  sortDisabled: true,
};

const lastBackfilledColumn: Column = {
  id: COLUMNS.LAST_BACKFILLED,
  label: 'Last Backfilled',
};

const scheduledDeactivationTimeColumn: Column = {
  id: COLUMNS.SCHEDULED_DEACTIVATION_TIME,
  label: 'Scheduled Deactivation Time',
  sortDisabled: true,
};

const expandColumn: Column = {
  id: COLUMNS.EXPAND,
  label: '',
  sortDisabled: true,
};

export const columns: Column[] = [
  checkboxColumn,
  expandColumn,
  statusColumn,
  teamNameColumn,
  teamIdColumn,
  tenantColumn,
  realmColumn,
  integrationsColumn,
  tagsColumn,
  scheduledDeactivationTimeColumn,
];
